<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Rencana Aksi SKPD (LV-IV)</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Jenis Renja</span>
                                <select class="form-control" v-model="form.renja_setup_id">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_renja_setup" :key="data.renja_setup_id" :value="data.renja_setup_id">{{data.renja_jenis}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">

                                    <th class="text-center" style="width: 5%">Kode</th>
                                    <th class="text-center" style="width: 20%">Sasaran/Program</th>
                                    <th class="text-center" style="width: 10%">Anggaran</th>
                                    <th class="text-center" style="width: 5%">Target</th>
                                    <th class="text-center" style="width: 30%">Pelaksana</th>
                                    <th class="text-center" style="width: 10%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                    <template>
                                        <tr class="h_isitable cetak_col_kop">
                                            <td class="tabel_center text-center" >xxxxx</td>
                                            <td class="tabel_center" colspan="5">Sasaran 1</td>
                                            
                                        </tr>
                                        <template>
                                            <tr class="h_isitable">
                                                <td class="tabel_center text-center" >xxxxx</td>
                                                <td class="tabel_center">Pembuatan Website OPD</td>
                                                <td class="">{{format_uang(0)}}</td>
                                                <td class="tabel_center">1 Unit</td>
                                                <td>
                                                    <ul>
                                                        <li>Kepala Bidang Sarana & Prasarana</li>
                                                    </ul>
                                                </td>
                                                <td class="tabel_center text-center" >
                                                    <button @click="selectData('data')" class="btn bg-light-blue btn-xs waves-effect" title="Lihat Detil" id="edit_data" data-toggle="modal" data-target="#m_lihat_data">
                                                        <i class="material-icons" >search</i>
                                                    </button>
                                                    &nbsp;
                                                    <button @click="selectData('data')" class="btn bg-light-green btn-xs waves-effect" title="Pilih Pejabat Pelaksana" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                                        <i class="material-icons" >account_box</i>
                                                    </button>
                                                    <!-- &nbsp;
                                                    <button @click="removeData('data.renja_dok_rencana_id')" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                        <i class="material-icons" >clear</i>
                                                    </button> -->

                                                </td>
                                            </tr>
                                        </template>
                                    </template>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RENSTRA TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">


                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Keterangan</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input type="text" class="form-control" v-model="form.renja_keterangan">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA PELAKSANA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Pejabat Pelaksana</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control">
                                                                    <option value="">-- Pilih Pejabat Pelaksana --</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea class="form-control"></textarea>
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">TAMBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-xlg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                
                                                <table style="width: 100%">
                                                    <tr>
                                                        <td style="width: 5%">Sasaran</td>
                                                        <td style="width: 2%">:</td>
                                                        <td >Sasaran 1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Program</td>
                                                        <td>:</td>
                                                        <td>Program 1</td>
                                                    </tr>
                                                </table>
                                                <hr>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered" style="width: 100%">
                                                        <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">

                                                            <th class="text-center" style="width: 5%">No</th>
                                                            <th class="text-center" style="width: 75%">Uraian Indikator</th>
                                                            <th class="text-center" style="width: 10%">Target</th>
                                                            <th class="text-center" style="width: 10%">Satuan</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable">
                                                                <td class="tabel_center text-center">1</td>
                                                                <td class="tabel_center">pejabat 1</td>
                                                                <td class="tabel_center"></td>
                                                                <td class="tabel_center"></td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <hr>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered" style="width: 100%">
                                                        <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">

                                                            <th class="text-center" style="width: 5%">No</th>
                                                            <th class="text-center" style="width: 40%">Pejabat Pelaksana</th>
                                                            <th class="text-center" style="width: 55%">Keterkaitan Tupoksi</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable">
                                                                <td class="tabel_center text-center">1</td>
                                                                <td class="tabel_center">pejabat 1</td>
                                                                <td class="tabel_center" >
                                                                    <ul>
                                                                        <li>Tupoksi 1</li>
                                                                    </ul>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>



                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_renja_dok_rencana/';




    const ADD_URL_SETUP_RENSTRA = URL_APP+'api/v1/planning_renja_setup/';

    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "",
        components: { Autocomplete },
        data() {
            return {
                form : {





                    renja_setup_id : '',
                    tahun : '',
                    instansi_id : '',
                    unit_kerja : '',
                },

                unit_kerja : '',
                unit_kerja_full : '',
                instansi_id : '',


                list_renja_setup :[],

                check_data_add : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.form.unit_kerja = get_profile.profile.unit_kerja;

            this.form.instansi_id = get_profile.profile.instansi_id;
            this.instansi_id = get_profile.profile.instansi_id;


            this.getDataTahun();
            this.getData();

            localStorage.sidemenu = 'sakip';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      renja_setup_id : this.form.renja_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){

                this.getDataTahun();
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){

            },

        //TAMBAHAN
            getSetupRenstra : function(){
                fetch(ADD_URL_SETUP_RENSTRA, {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        tahun : this.form.tahun,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_renja_setup = res_data;

                    if (res_data.length <= 0) {
                        this.form.renja_setup_id = '';
                        this.check_data_add = false;
                    }else{
                        this.form.renja_setup_id = res_data[0].renja_setup_id
                        this.getData();
                    }

                    // console.log(res_data[0]);



                })
            },



        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;

                this.getDataTahun();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                
                if (this.form.renja_setup_id != '') {
                    this.check_data_add = true;
                }
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    this.form.tahun = this.getTgl().tahun;
                    // console.log(res_data);

                    this.getSetupRenstra();
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (angka == null || angka == '' || angka == undefined) {
                    return angka;
                } else {
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                }
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
